const navHome = document.querySelector(".nav-home");
const navAbout = document.querySelector(".nav-about");
const navMenu = document.querySelector(".nav-menu");
const navHang = document.querySelector(".nav-hangout");
const navCommt = document.querySelector(".nav-comment");
const navCont = document.querySelector(".nav-contact");
const hangBtn = document.querySelector(".hangbtn");
const nav2Home = document.querySelector(".nav2-home");
const nav2About = document.querySelector(".nav2-about");
const nav2Menu = document.querySelector(".nav2-menu");
const nav2Hang = document.querySelector(".nav2-hangout");
const nav2Commt = document.querySelector(".nav2-comment");
const nav2Cont = document.querySelector(".nav2-contact");
const bottomAbout = document.querySelector(".six__about--a");

const homepageId = document.querySelector("#section-home");
const aboutPageId = document.querySelector("#section-about");
const menuPageId = document.querySelector("#section-menu");
const hangPageId = document.querySelector("#section-hangout");
const commtPageId = document.querySelector("#section-comment");
const contPageId = document.querySelector("#section-contact");

navHome.addEventListener("click", function () {
  homepageId.scrollIntoView({ behavior: "smooth" });
});

navAbout.addEventListener("click", function () {
  aboutPageId.scrollIntoView({ behavior: "smooth" });
});

navMenu.addEventListener("click", function () {
  menuPageId.scrollIntoView({ behavior: "smooth" });
});

navHang.addEventListener("click", function () {
  hangPageId.scrollIntoView({ behavior: "smooth" });
});

navCommt.addEventListener("click", function () {
  commtPageId.scrollIntoView({ behavior: "smooth" });
});

navCont.addEventListener("click", function () {
  contPageId.scrollIntoView({ behavior: "smooth" });
});

hangBtn.addEventListener("click", function () {
  hangPageId.scrollIntoView({ behavior: "smooth" });
});

nav2Home.addEventListener("click", function () {
  homepageId.scrollIntoView({ behavior: "smooth" });
});

nav2About.addEventListener("click", function () {
  aboutPageId.scrollIntoView({ behavior: "smooth" });
});

nav2Menu.addEventListener("click", function () {
  menuPageId.scrollIntoView({ behavior: "smooth" });
});

nav2Hang.addEventListener("click", function () {
  hangPageId.scrollIntoView({ behavior: "smooth" });
});

nav2Commt.addEventListener("click", function () {
  commtPageId.scrollIntoView({ behavior: "smooth" });
});

nav2Cont.addEventListener("click", function () {
  contPageId.scrollIntoView({ behavior: "smooth" });
});

bottomAbout.addEventListener("click", function () {
  aboutPageId.scrollIntoView({ behavior: "smooth" });
});

//Policy

const policy = document.querySelector(".six__policy--txt");
const policyBox = document.querySelector(".policy");
const policyDone = document.querySelector(".done");

policy.addEventListener("click", function () {
  policyBox.classList.remove("hidden");
});

policyDone.addEventListener("click", function () {
  policyBox.classList.add("hidden");
});

// Menu Tabp
const menuPage = document.querySelector(".three");
const simple = document.querySelector(".three__simple");
const brew = document.querySelector(".three__brew");
const cold = document.querySelector(".three__cold");
const sim = document.querySelector(".three__sim");
const bre = document.querySelector(".three__bre");
const col = document.querySelector(".three__col");

menuPage.addEventListener("click", function (e) {
  // console.log(e.target.dataset.id);
  const id = e.target.dataset.id;

  if (id) {
    simple.classList.remove("active");
    brew.classList.remove("active");
    cold.classList.remove("active");

    e.target.classList.add("active");
    sim.classList.add("hidden");
    bre.classList.add("hidden");
    col.classList.add("hidden");

    const removeHiden = document.getElementById(id);
    removeHiden.classList.remove("hidden");
  }
});

// Form Validation
const inputname = document.querySelector(".inputname");
const inputtxt = document.querySelector(".inputtxt");
const inputemail = document.querySelector(".inputemail");
const emailtxt = document.querySelector(".emailtxt");
const inputphone = document.querySelector(".inputphone");
const numbertxt = document.querySelector(".numbertxt");
const person = document.querySelector(".person");
const persontxt = document.querySelector(".persontxt");
const time = document.querySelector(".time");
const timetxt = document.querySelector(".timetxt");
const subbtn = document.querySelector(".four__subbtn");
const date = document.querySelector(".date");
const datetxt = document.querySelector(".datetxt");
const overlay = document.querySelector(".four__overlay");
const overlayclbtn = document.querySelector(".four__closebtn");
const four = document.querySelector(".four");
const textarea = document.querySelector(".textarea");

subbtn.addEventListener("click", function () {
  if (inputname.value === "") {
    inputtxt.innerHTML = "Please Type your name";
  } else if (inputemail.value === "") {
    emailtxt.innerHTML = "Please Type your Email Address";
  } else if (inputphone.value === "") {
    numbertxt.innerHTML = "Please Type your Phone Number";
  } else if (person.options[person.selectedIndex].value === "Select") {
    persontxt.innerHTML = "Please Select the Person";
  } else if (date.value === "") {
    datetxt.innerHTML = "Please Select the Date";
  } else if (time.options[time.selectedIndex].value === "choose") {
    timetxt.innerHTML = "Please Select the Time";
  } else {
    inputtxt.innerHTML = "";
    emailtxt.innerHTML = "";
    numbertxt.innerHTML = "";
    persontxt.innerHTML = "";
    datetxt.innerHTML = "";
    timetxt.innerHTML = "";
    inputname.value = "";
    inputemail.value = "";
    inputphone.value = "";
    person.selectedIndex = 0;
    date.value = "";
    time.selectedIndex = 0;
    textarea.value = "";
    overlay.classList.remove("hidden");
  }
});

overlayclbtn.addEventListener("click", function () {
  overlay.classList.add("hidden");
});

four.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    overlay.classList.add("hidden");
  }
});

overlay.addEventListener("click", function () {
  overlay.classList.add("hidden");
});

// Comment Slider
const slides = document.querySelectorAll(".five__slide");
const rightbtn = document.querySelector(".five__rightbtn");
const leftbtn = document.querySelector(".five__leftbtn");
const dotContainer = document.querySelector(".five__dots");
const leftbtn2 = document.querySelector(".five__leftbtn2");
const rightbtn2 = document.querySelector(".five__rightbtn2");

let curSlide = 0;
const maxSlide = slides.length;

const createsDots = function () {
  slides.forEach(function (_, i) {
    dotContainer.insertAdjacentHTML(
      "beforeend",
      `<button class="five__dots__dot" data-slide="${i}"></button>`
    );
  });
};

createsDots();

const activateDot = function (slide) {
  document
    .querySelectorAll(".five__dots__dot")
    .forEach((dot) => dot.classList.remove("five__dots__dot--active"));

  document
    .querySelector(`.five__dots__dot[data-slide="${slide}"]`)
    .classList.add("five__dots__dot--active");
};

activateDot(0);

slides.forEach((s, i) => (s.style.transform = `translateX(${100 * i}%)`));

rightbtn.addEventListener("click", function () {
  if (curSlide === maxSlide - 1) {
    curSlide = 0;
  } else {
    curSlide++;
  }

  slides.forEach(
    (s, i) => (s.style.transform = `translateX(${100 * (i - curSlide)}%)`)
  );

  activateDot(curSlide);
});

leftbtn.addEventListener("click", function () {
  if (curSlide === 0) {
    curSlide = maxSlide - 1;
  } else {
    curSlide--;
  }

  slides.forEach(
    (s, i) => (s.style.transform = `translateX(${100 * (i - curSlide)}%)`)
  );

  activateDot(curSlide);
});

document.addEventListener("keydown", function (e) {
  if (e.key === "ArrowLeft") {
    if (curSlide === 0) {
      curSlide = maxSlide - 1;
    } else {
      curSlide--;
    }

    slides.forEach(
      (s, i) => (s.style.transform = `translateX(${100 * (i - curSlide)}%)`)
    );
    activateDot(curSlide);
  }

  if (e.key === "ArrowRight") {
    if (curSlide === maxSlide - 1) {
      curSlide = 0;
    } else {
      curSlide++;
    }

    slides.forEach(
      (s, i) => (s.style.transform = `translateX(${100 * (i - curSlide)}%)`)
    );
    activateDot(curSlide);
  }
});

dotContainer.addEventListener("click", function (e) {
  if (e.target.classList.contains("five__dots__dot")) {
    const { slide } = e.target.dataset;
    slides.forEach(
      (s, i) => (s.style.transform = `translateX(${100 * (i - slide)}%)`)
    );
    activateDot(slide);
  }
});

leftbtn2.addEventListener("click", function () {
  if (curSlide === 0) {
    curSlide = maxSlide - 1;
  } else {
    curSlide--;
  }

  slides.forEach(
    (s, i) => (s.style.transform = `translateX(${100 * (i - curSlide)}%)`)
  );

  activateDot(curSlide);
});

rightbtn2.addEventListener("click", function () {
  if (curSlide === maxSlide - 1) {
    curSlide = 0;
  } else {
    curSlide++;
  }

  slides.forEach(
    (s, i) => (s.style.transform = `translateX(${100 * (i - curSlide)}%)`)
  );

  activateDot(curSlide);
});
